import PublicWrapper from "app/components/PublicWrapper";
import DateTimeCoachSlots from "app/routes/Sessions/DateTimeCoachSlots";
import React, { memo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "typedefs";

const FacilityTimeSlots = () => {
    const bookSessionData = useSelector((state: RootState) => state.bookSession);

    return (
        <PublicWrapper>
            <DateTimeCoachSlots bookSession={bookSessionData} />
        </PublicWrapper>
    );
};

export default memo(FacilityTimeSlots);
